import { useCallback, useContext } from "react";

import { getDafProvider } from "@simplyk/common";

import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

export const useDafTracking = () => {
  const { logAmplitudeEvent } = useAmplitude();
  const { commandId, formData, formAmplitudeContext, displayedFormAmount, dafExposureAmount } =
    useContext(FrontendFormContext);
  const trackDaf = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      logAmplitudeEvent(event, {
        ...formAmplitudeContext,
        formId: formData.id,
        commandId,
        amount: displayedFormAmount / 100,
        hasDafOption: "dafEnabled" in formData && Boolean(formData.dafEnabled),
        hasSeenDaf: dafExposureAmount?.current !== undefined && dafExposureAmount.current !== null,
        ...properties,
      });
    },
    [logAmplitudeEvent, commandId, formData, formAmplitudeContext, displayedFormAmount, dafExposureAmount]
  );
  return { trackDaf, dafExposureAmount };
};

export const getDafTrackingProperties = (providerId: string | null | undefined) => {
  const provider = getDafProvider(providerId);
  return {
    dafProviderId: provider?.id,
    dafProvider: provider?.name,
    DAF_method: provider?.dafDirect ? "DAFDirect" : "Custom",
  };
};
